import { Select } from "antd";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

const { Option } = Select;

export function DropdownSelect({
  title,
  options,
  setSelectedValue,
  defaultValue,
}: any) {
  const [maxWidth, setMaxWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    const maxOptionWidth = options.reduce(
      (maxWidth: number, option: string) => {
        const optionWidth = getTextWidth(option);
        return optionWidth > maxWidth ? optionWidth : maxWidth;
      },
      0
    );
    setMaxWidth(maxOptionWidth + 60); // Add some extra padding
  }, [options]);

  const getTextWidth = (text: string) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = "14px sans-serif"; // Use the same font size as the Select component
      return context.measureText(text).width;
    }
    return 0;
  };

  const handleSelectChange = (value: string) => {
    // Determine which handler to call based on the title of the dropdown

    setSelectedValue(value);
  };

  return (
    <div>
      <p className={styles.dropdownTitle}>{title}</p>
      <Select
        style={{ width: maxWidth }}
        defaultValue={defaultValue} // Set the default value here
        onChange={handleSelectChange}
      >
        {options.map((option: any) => (
          <Option key={option} value={option}>
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
}
